<!--
 * @Author: zouyuping
 * @version:
 * @Date: 2020-10-14 11:12:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-10 19:37:59
 * @FilePath: 
 * @Description: 挂号单详情页
-->
<template>
  <div class="page-container">
    <div
      class="detail_header_con"
      :style="{
        background: orderDetail.Status == 4 ? '#F5F8FF' : '#E6FFE6',
      }"
    >
      <i
        :class="
          'iconfont ' +
          (orderDetail.Status == 4 ? 'icon-shanchu' : 'icon-queren')
        "
        :style="{
          color: orderDetail.Status == 4 ? '#bdbdbd' : '#2BCF2B',
        }"
      ></i>
      {{ statusObj[orderDetail.Status] }}
    </div>
    <div class="c-bg-white c-m-b-20 history_item_con">
      <div class="c-fl-bt history_top_con">
        <div>{{ VpnName }}</div>
        <div>号码：{{ orderDetail.Number }}</div>
      </div>
      <div class="history_bottom_con">
        <div class="f-bt m-b-16">
          <div class="c-f">
            <p class="result_title_con">预约人</p>
            <p>{{ orderDetail.Member }}</p>
          </div>
          <div class="c-f">
            <p class="result_title_con result_title_con_small">手机号</p>
            <p>{{ orderDetail.Mobile }}</p>
          </div>
          <div class="c-f" v-if="isNeedCheckNumber">
            <p class="result_title_con result_title_con_small">预约人数</p>
            <p>{{ orderDetail.BookingNumberOfPeople }}</p>
          </div>
        </div>

        <div class="c-f m-b-16">
          <p class="result_title_con">会员卡</p>
          <p>{{ orderDetail.CardTypeName }}</p>
        </div>
        <div class="c-f m-b-16">
          <p class="result_title_con">预约项目</p>
          <p>{{ orderDetail.GoodsName }}</p>
        </div>
        <div class="c-f m-b-16" v-if="showJIshi">
          <p class="result_title_con">预约诊疗师</p>
          <p>{{ orderDetail.JiShiName }}</p>
        </div>
        <div class="c-f">
          <p class="result_title_con">预约时间</p>
          <p>{{ orderDetail.PeriodTime }}</p>
        </div>
      </div>
    </div>
    <div class="m-t-200 c-fc-center p-lr-120" v-if="orderDetail.Status != 4">
      <van-button
        color="var(--tc)"
        block
        @click="handleCancelBook"
        style="margin-bottom: 12px"
        >取消预约</van-button
      >
      <van-button
        color="var(--tc)"
        plain
        block
        v-if="canChangePeriod"
        @click="handleAnewBook"
        >重新选择预约时间</van-button
      >
    </div>
  </div>
</template>

<script>
import { testGetAESPhone, silentLogin } from "@/api/user";
import { setToken, getToken } from "@/utils/auth";
import { getStoreBanner } from "@/api/system";
import { getUserOrderList } from "@/api/order";
import { getBookRegisterDetail, cancelBookRegister } from "@/api/bookRegister";
import { handleTimeLocalStorage } from "@/utils";
import { Dialog } from "vant";
export default {
  name: "Order",
  data() {
    return {
      statusObj: { 1: "已挂号", 2: "已叫号", 3: "已就诊", 4: "已取消" },
      VpnName: "",
      canChangePeriod: false,
      showJIshi: false,
      isNeedCheckNumber: false,
      orderDetail: {
        // CreatTime: "2023-07-28 12:23:09",
        // BookNumber: "125",
        // PersonName: "张三",
        // MemberPhone: "1321212125",
        // CardType: "尊享会员卡",
        // ProjectName: "康复推拿",
        // JishiName: "专家1",
        // PeriodTime: "2023-07-28 09:00-12:00",
        // BookingNumberOfPeople: 1,
        // StatusName: "已预约",
        // VpnName: "清华池",
      },
    };
  },

  created() {
    this.bookId = this.$route.query.BookId;
    this.VpnName = this.$store.state.vpnInfo.name;
    const bookConfigData = handleTimeLocalStorage.get("bookConfig");
    this.canChangePeriod = bookConfigData.TimeSpanChangeStatusId == 1;
    this.showJIshi = bookConfigData.JsStatusId == 1;
    this.isNeedCheckNumber = bookConfigData.BookingNumberOfPeople == 1;
    this.handleGetBookDetail();
  },

  methods: {
    handleGetBookDetail() {
      getBookRegisterDetail({
        Id: this.bookId,
        VpnId: this.$store.state.vpnId,
      }).then((res) => {
        res.PeriodTime = res.Taken.split(" ")[0] + " " + res.TimeSpan;

        this.orderDetail = res;
      });
    },
    handleCancelBook() {
      Dialog.confirm({
        title: "取消提醒",
        message: "确认取消预约吗？",
        cancelButtonText: "否",
        confirmButtonText: "是",
      })
        .then(() => {
          cancelBookRegister({
            Id: this.bookId,
            VpnId: this.$store.state.vpnId,
          }).then((res) => {
            this.handleGetBookDetail();
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    handleAnewBook() {
      handleTimeLocalStorage.set("pointProject", {
        Name: this.orderDetail.GoodsName,
        Id: this.orderDetail.GoodsId,
        JishiId: this.orderDetail.JiShiId,
        JishiName: this.orderDetail.JiShiName,
      });
      this.$router.push({
        name: "SelectPeriod",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  min-height: 100vh;
  box-sizing: border-box;
}
.detail_header_con {
  padding: 15px 20px;
  background: #fff;
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 15px;
  .iconfont {
    font-size: 34px;
    // width: 40rpx;
    // height: 40rpx;
    // vertical-align: middle;
    margin-right: 12px;
  }
}
.history_top_con {
  line-height: 70px;
  border-bottom: 1px dashed #dedede;
  font-size: 22px;
}
.history_item_con {
  margin: 32px;
  padding: 0 24px;
  background: #ffffff;
  box-shadow: 0px 2px 0px 0px rgba(194, 194, 194, 0.5);
  border-radius: 12px;
  font-size: 24px;
  color: #333;

  .result_title_con {
    width: 120px;
    color: #666;
    font-size: 22px;

    &.result_title_con_small {
      width: unset;
      margin-right: 12px;
    }
  }
  .history_bottom_con {
    padding: 24px 0;
  }
}
.order_name_con {
  width: 130px;
}
</style>
